import React from 'react';
import { Row } from 'react-bootstrap';

const SuccessMessage = (props) => {
    return (
        <>
            <Row>
                <h2 style={{ margins: '30px' }}><b>Applicant ID:</b></h2>
            </Row>
            <br />
            <Row>
                <h1 style={{ textAlign: 'center', color: 'red' }}><u>{props.Id}</u></h1>
            </Row >
        </>
    )
}
export default SuccessMessage;
